import { createPortal } from 'react-dom';
import { C, t } from '../constants/dashboardConstants';
import { getScheduleAccentBackground, normalizeScheduleColor } from './scheduleColors';

const KO_DAYS = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'];

export default function DayEventsModal({ date, events, onClose, onDelete, onEdit }) {
  const d = new Date(date);
  const title = `${d.getFullYear()}년 ${d.getMonth() + 1}월 ${d.getDate()}일 ${KO_DAYS[d.getDay()]}`;
  const showActions = Boolean(onDelete || onEdit);

  return createPortal(
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: C.white, borderRadius: '20px',
          padding: '60px 50px', width: '780px', maxHeight: '80vh',
          overflowY: 'auto', boxSizing: 'border-box',
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: events.length > 0 ? '8px' : '30px' }}>
          <span style={t('28px', 700, C.bk)}>{title}</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke={C.g400} strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {events.length > 0 && (
          <div style={{ ...t('14px', 400, C.sub), marginBottom: '30px' }}>총 {events.length}개의 일정</div>
        )}

        {events.length === 0 ? (
          <div style={{
            background: C.bg, border: `1px solid ${C.g200}`, borderRadius: '12px',
            display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px',
          }}>
            <span style={t('16px', 400, C.sub)}>예정된 일정이 없습니다.</span>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {events.map(ev => {
              const color = normalizeScheduleColor(ev.color || ev.eventColor);
              return (
              <div key={ev.id} style={{
                background: C.white, border: `1px solid ${color}`,
                borderRadius: '12px', overflow: 'hidden',
              }}>
                {/* Event title row */}
                <div style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '20px 24px', borderBottom: `1px solid ${color}`,
                  background: getScheduleAccentBackground(color),
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ width: '10px', height: '10px', borderRadius: '999px', background: color, flexShrink: 0 }} />
                    <span style={t('18px', 600, color)}>{ev.title}</span>
                  </div>
                  {showActions && (
                  <div style={{ display: 'flex', gap: '12px' }}>
                    {onDelete && <button onClick={() => onDelete(ev.id)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M3 6h18M19 6l-1 14H6L5 6M10 11v6M14 11v6M9 6V4h6v2" stroke={C.g400} strokeWidth="1.5" strokeLinecap="round"/>
                      </svg>
                    </button>}
                    {onEdit && <button onClick={() => onEdit(ev)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke={C.g400} strokeWidth="1.5" strokeLinecap="round"/>
                        <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke={C.g400} strokeWidth="1.5" strokeLinecap="round"/>
                      </svg>
                    </button>}
                  </div>
                  )}
                </div>

                {/* Time + Location */}
                <div style={{ padding: '20px 24px', borderBottom: ev.description ? `1px solid ${C.g200}` : 'none' }}>
                  <div style={{ display: 'flex', gap: '60px' }}>
                    <div>
                      <div style={{ ...t('14px', 400, C.sub), marginBottom: '8px' }}>시간</div>
                      <div style={t('16px', 400, C.bk)}>{ev.time}</div>
                    </div>
                    {ev.location && (
                      <div>
                        <div style={{ ...t('14px', 400, C.sub), marginBottom: '8px' }}>장소</div>
                        <div style={t('16px', 400, C.bk)}>{ev.location}</div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Description */}
                {ev.description && (
                  <div style={{ padding: '20px 24px' }}>
                    <div style={{ ...t('14px', 400, C.sub), marginBottom: '8px' }}>세부 정보</div>
                    <div style={t('16px', 400, C.bk)}>{ev.description}</div>
                  </div>
                )}
              </div>
            );
            })}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}
